// Line-count audit (2026-05-04): 59 lines.
import { dimensionIsolationService, type DimensionPropertyChange } from '@/services/ai/DimensionIsolationService';
import { valueNormalizationService } from '@/services/ai/ValueNormalizationService';
import type { ComponentSnapshot } from '@/services/ai/CommandStateManager';
import type { Component } from '@/types';

export function filterDimensionChanges(
  command: string,
  changes: DimensionPropertyChange,
  targetComponent: Component | null,
  stateSnapshot?: ComponentSnapshot | null
): DimensionPropertyChange {
  if (!changes || !targetComponent) {
    return changes;
  }

  let currentWidth = 0;
  let currentHeight = 0;

  if (stateSnapshot) {
    const widthVal = stateSnapshot.size?.width;
    const heightVal = stateSnapshot.size?.height;
    currentWidth = typeof widthVal === 'number' ? widthVal
      : typeof widthVal === 'string' ? parseFloat(widthVal) || 0
      : 0;
    currentHeight = typeof heightVal === 'number' ? heightVal
      : typeof heightVal === 'string' ? parseFloat(heightVal) || 0
      : 0;
  } else {
    const style = targetComponent.responsivePosition?.breakpoints?.desktop?.style || targetComponent.style || {};
    const size = targetComponent.size || {};
    const widthVal = style.width ?? size.width;
    const heightVal = style.height ?? size.height;
    currentWidth = typeof widthVal === 'number' ? widthVal
      : typeof widthVal === 'string' ? parseFloat(widthVal) || 0
      : 0;
    currentHeight = typeof heightVal === 'number' ? heightVal
      : typeof heightVal === 'string' ? parseFloat(heightVal) || 0
      : 0;
  }

  const isolationResult = dimensionIsolationService.processChanges(
    command,
    changes,
    { width: currentWidth, height: currentHeight }
  );

  const normalizationResult = valueNormalizationService.normalizePropertyChanges(
    isolationResult.changes,
    { width: currentWidth, height: currentHeight },
    isolationResult.analysis
  );

  return normalizationResult.changes;
}

export function isDimensionPropertyChange(value: unknown): value is DimensionPropertyChange {
  return typeof value === 'object' && value !== null;
}
